import React from 'react';
import type { Rack, Recipe } from '@recipe-rack/shared';

import RecipeCard from './RecipeCard';

export interface RackRowProps {
  /** Display name for the section heading. */
  title: string;
  /** Recipes to render in this row. */
  recipes: Recipe[];
  /** All racks — passed through to RecipeCard for pill rendering. */
  racks: Rack[];
  /** Subtle right-aligned link (e.g. "See all ›"). Click handler optional. */
  seeAll?: { label: string; onClick: () => void };
  selectedRecipeId?: string | null;
  onSelectRecipe: (recipeId: string) => void;
}

/**
 * Editorial section: rack name heading + horizontal scroll of recipe cards.
 * Uses `.hide-scrollbar` so the row reads cleanly on touch + trackpad.
 */
const RackRow: React.FC<RackRowProps> = ({
  title,
  recipes,
  racks,
  seeAll,
  selectedRecipeId,
  onSelectRecipe,
}) => {
  if (recipes.length === 0) return null;
  return (
    <section className="rr-rackrow">
      <header className="rr-rackrow-head">
        <div className="rr-rackrow-name">
          <span className="rr-rackrow-dot" aria-hidden="true" />
          <h2 className="rr-rackrow-title">{title}</h2>
          <span className="rr-rackrow-count">{recipes.length}</span>
        </div>
        {seeAll && (
          <button type="button" className="rr-rackrow-see" onClick={seeAll.onClick}>
            {seeAll.label}
          </button>
        )}
      </header>
      <div className="rr-rackrow-scroll hide-scrollbar">
        {recipes.map((r) => (
          <RecipeCard
            key={r.recipeId}
            recipe={r}
            racks={racks}
            isOpen={selectedRecipeId === r.recipeId}
            onClick={onSelectRecipe}
          />
        ))}
      </div>
    </section>
  );
};

export default RackRow;
